




import { Component, Vue, Prop } from "vue-property-decorator";
import { mdiGenderFemale, mdiGenderMale } from "@mdi/js";
import { DataPoint, Name } from "../models";
type Gender = "boy" | "girl";

@Component({})
export default class GenderIcon extends Vue {
  @Prop()
  gender!: Gender;

  femaleIcon = mdiGenderFemale;
  maleIcon = mdiGenderMale;
}
